import { VALIDATION_GROUP } from "@thrivecoin/adapter/dist/types";

export const BLOCKCHAIN_EXPLORER_DOMAINS = [
  "hashscan.io",
  "polygonscan.com",
  "bscscan.com",
  "etherscan.io",
  "arbiscan.io",
  "apescan.io",
  "zkscan.io",
  "dune.com",
  "optimistic.etherscan.io",
  "ftmscan.com",
  "hederaexplorer.io",
  "celoscan.io",
  "moonbeanscan.io",
  "bobascan.com",
  "snowtrace.io",
  "basescan.org",
  "explorer.zora.energy",
  "blockscout.com",
  "explorer.sonic.network",
  "scrollscan.com",
];

export const SOCIAL_DOMAINS = [
  "github.com",
  "youtube.com",
  "youtu.be",
  "discord.gg",
  "discord.com",
  "twitter.com",
  "x.com",
  "telegram.me",
  "t.me",
  "linkedin.com",
  "farcaster.xyz",
];

export const DOCUMENTATION_DOMAINS = [
  "drive.google.com",
  "loom.com",
  "docs.google.com",
  "notion.so",
  "notion.site",
  "confluence.atlassian.com",
  "readme.io",
  "gitbook.io",
];

export const GROUP_TO_DOMAINS: Partial<Record<VALIDATION_GROUP, readonly string[]>> = {
  [VALIDATION_GROUP.BLOCKCHAIN_EXPLORER]: BLOCKCHAIN_EXPLORER_DOMAINS,
  [VALIDATION_GROUP.SOCIAL]: SOCIAL_DOMAINS,
  [VALIDATION_GROUP.DOCUMENTATION]: DOCUMENTATION_DOMAINS,
};

export const MILESTONE_SUMMARY_MAX_LENGTH = 1000;
